class Dropdown
{
    constructor(dropdownSelector = '.dropdown')
    {
        this.dropdowns = document.querySelectorAll(dropdownSelector);

        if(this.dropdowns) {
            this.init();
        }
    }

    init()
    {
        //when a dropdown is clicked, open it
        Array.from(this.dropdowns).forEach((dropdown) => {
            this.initDropdown(dropdown);
            this.initOptions(dropdown);
        });

        // general body clicked
        document.querySelector('body').addEventListener('click', (e) => {
            this.bodyClicked(e.target);
        });
    }

    bodyClicked(target)
    {
        // if the target is not a dropdown or is not an ancestor of a dropdown, close all dropdowns
        if (!target.classList.contains('dropdown') && !target.closest('.dropdown')) {
            this.closeAllDropdowns();
        }
    }

    initDropdown(dropdown)
    {
        dropdown.opened = false;

        dropdown.addEventListener('click', (e) => {
            if (!dropdown.opened) {
                this.openDropdown(dropdown);
            } else {
                this.closeDropdown(dropdown);
            }
        });
    }

    uncheckOtherOptions(dropdown, option)
    {
        if (dropdown.options) {
            Array.from(dropdown.options).forEach((tempOption) => {
                if (tempOption !== option) {
                    tempOption.checked = false;
                }
            });
        }
    }

    initOptions(dropdown)
    {
        const options = dropdown.querySelectorAll('input');
        dropdown.options = options;

        Array.from(options).forEach((option) => {
            option.addEventListener('change', (e) => {
                option.checked = true;
                this.uncheckOtherOptions(dropdown, option);
                this.closeDropdown(dropdown);
            });
        });
    }

    openDropdown(dropdown)
    {
        dropdown.classList.add('dropdown--selected');
        dropdown.opened = true;
        this.closeOtherDropdowns(dropdown);
    }

    closeDropdown(dropdown)
    {
        dropdown.opened = false;
        dropdown.classList.remove('dropdown--selected');
    }

    closeOtherDropdowns(dropdown)
    {
        Array.from(this.dropdowns).forEach((tempDropdown) => {
            if(tempDropdown !== dropdown) {
                this.closeDropdown(tempDropdown);
            }
        });
    }

    closeAllDropdowns()
    {
        Array.from(this.dropdowns).forEach((dropdown) => {
            this.closeDropdown(dropdown);
        });
    }
}

export default Dropdown;
